import React from 'react';
import StudentDecisionReport from './StudentDecisionReport';
export default function YearlyReport(){return <StudentDecisionReport mode="yearly"/>;}
